module.exports = __webpack_public_path__ + "static/media/waitlist-member-9.39eca4c2.jpeg";